import { useEffect } from "react";
import Banner from "../components/Banner";
import MissionVision from "../components/MissionVision";
import Capacity from "../components/Capacity";
import EnergyAssets from "../components/EnergyAssets";
import ChartMap from "../components/chart-map/ChartMap";
import NewsEvents from "../components/latestnews_events/NewsEvents";
import PhotoVideoPublication from "../components/photo_video_publication/PhotoVideoPublication";
import Announcement from "../components/Announcement";
import AboutNeepco from "../components/AboutNeepco";
import CsrAndChallengesSection from "../components/csr_chalenges/CsrAndChallengesSection";
import BottomSlider from "../components/shared/footer/BottomSlider";
import useSeo from "../hooks/useSeo";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";
import { setExternalLink, setShowHomePopup } from "../redux/slice/slicePopup";
import WOW from "wowjs";
import "animate.css";

function Home() {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { pathname } = useLocation();
  const dispatch = useDispatch();

  useSeo({ pathname });

  const { data: homePopupData = [], isLoading: homePopupIsLoading } =
    useGetProtectedApiDataQuery({
      url: "home_popup",
      lang: languageType,
    });

  useEffect(() => {
    if (
      !homePopupIsLoading &&
      homePopupData[0]?.field_status_of_popup === "On"
    ) {
      dispatch(setExternalLink(homePopupData[0]?.body));
      dispatch(setShowHomePopup(true));
    } else if (!homePopupIsLoading) {
      dispatch(setShowHomePopup(false));
    }
  }, [homePopupData, homePopupIsLoading, dispatch]);

  // useEffect(() => {
  //   const wow = new WOW.WOW();
  //   wow.init();
  // }, [pathname]);

  return (
    <>
      <Banner />
      <Announcement />
      <AboutNeepco />
      <MissionVision />
      <Capacity />
      <EnergyAssets />
      <ChartMap />
      <CsrAndChallengesSection />
      <NewsEvents />
      <PhotoVideoPublication />
      <BottomSlider />
    </>
  );
}

export default Home;
